import { Injectable } from '@angular/core';
import { BehaviorSubject, lastValueFrom } from 'rxjs';
import { BaseService } from './base.service';
import { ApiVersions } from './api-version';
import { TeamManagersModel } from 'src/app/teams/team-managers/team-managers.model';

@Injectable({
  providedIn: 'root'
})
export class TeamManagerService extends BaseService {
  public readonly teamManagers = new BehaviorSubject<TeamManagersModel[]>([]);

  private getTeamManagersUrl = (teamId: string, additionalParams?: string): string =>
    additionalParams ? `teams/${teamId}/managers/${additionalParams}` : `teams/${teamId}/managers`;

  getTeamManagers(teamId: string) {
    this.teamManagers.next([]);
    lastValueFrom(
      this.get<TeamManagersModel[]>(this.getTeamManagersUrl(teamId), true, ApiVersions.v1_0)
    ).then((data) => {
      if (!data) {
        return;
      }
      const managers = data.map((manager) => TeamManagersModel.parse(manager));
      this.teamManagers.next(managers);
    });

    return this.teamManagers;
  }

  addTeamManager = (teamId: string, personId: string) =>
    lastValueFrom(
      this.post(this.getTeamManagersUrl(teamId, personId), undefined, null, ApiVersions.v1_0)
    ).then((result) => {
      const newManager = TeamManagersModel.parse(result);
      if (!newManager) {
        return null;
      }

      this.teamManagers.next([...this.teamManagers.value, newManager]);
      this.openSnackBar('Team manager added successfully', true);

      return newManager;
    });

  deleteTeamManager = (teamId: string, managerId: string) =>
    lastValueFrom(
      this.delete(this.getTeamManagersUrl(teamId, managerId), null, ApiVersions.v1_0)
    ).then((isSuccessful) => {
      if (!isSuccessful) {
        return false;
      }
      const currentManagers = this.teamManagers.value;
      this.teamManagers.next(currentManagers.filter((manager) => manager.id !== managerId));
      this.openSnackBar('Team manager deleted successfully', true);

      return true;
    });
}
